import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Text,
  Center,
} from "@chakra-ui/react";
import { StyledVerifyButton } from "../styles"; // use your existing button style
import SuccessCheckIcon from "../password-successful/successicon";
import { useTranslation } from "react-i18next";

const EmailUpdatedModal = ({ isOpen, onClose }: EmailUpdatedModalProps) => {
  const { t } = useTranslation("common");
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnEsc={false}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent borderRadius="16px" maxW="420px" bg="#FFFFFF">
        <ModalCloseButton />

        <ModalBody>
          <Center flexDirection="column" py={10}>
            <SuccessCheckIcon boxSize={10} color="green.500" />
            <Text
              fontSize="20px"
              fontWeight="700"
              textAlign="center"
              mb={2}
              mt={3}
            >
              {t("userProfile.emailUpdated")}
            </Text>

            <Text fontSize="14px" color="#6B7280" textAlign="center" mb={6}>
              {t("userProfile.updateInstruction")}
            </Text>
            <StyledVerifyButton onClick={onClose}>
              {t("userProfile.continue")} &rarr;
            </StyledVerifyButton>
          </Center>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default EmailUpdatedModal;
